import { client } from "../../../api/client";
import { base64ToBlob } from "../../../utils/base64Utils";

export const downloadItemsTemplate = async () => {
  if (process.env.REACT_APP_USELOCALDATA === "true") {
    return base64ToBlob(require("./_local/_itemsTemplate.json").excelData);
  } else {
    try {
      const response = await client.get(process.env.REACT_APP_GATEWAY_URI,"iquoteapi/itemLookup/downloaditemstemplate");
      return response.data;
    } catch (error) {
        console.error("Error downloading items template:", error);
        return [];
    }
  }
};

export const exportItems = async (body) => {
  if (process.env.REACT_APP_USELOCALDATA === "true") {
    return null;
  } else {
    try {
      const response = await client.post(process.env.REACT_APP_GATEWAY_URI,"iquoteapi/itemLookup/exportitems", body);
      return response.data;
    } catch (error) {
        console.error("Error exporting items:", error);
        return [];
    }
  }
};

export const fetchItemLookupColumns = async () => {
  if (process.env.REACT_APP_USELOCALDATA === "true") {
    return null;
  } else {
    try {
      const response = await client.get(process.env.REACT_APP_GATEWAY_URI,"iquoteapi/itemLookup/getitemlookupcolumns");
      return response.data;
    } catch (error) {
        console.error("Error getting item lookup columns:", error);
        return [];
    }
  }
};

export const importItems = async (body) => {
  if (process.env.REACT_APP_USELOCALDATA === "true") {
    return null;
  } else {
    try {
      const response = await client.post(process.env.REACT_APP_GATEWAY_URI,"iquoteapi/itemLookup/importitems", body);
      return response;
    } catch (error) {
        console.error("Error importing items:", error);
        return [];
    }
  }
};

export const importAndSaveItems = async (body) => {
  if (process.env.REACT_APP_USELOCALDATA === "true") {
    return null;
  } else {
    try {
      const response = await client.post(process.env.REACT_APP_GATEWAY_URI,"iquoteapi/itemLookup/importandsaveitems", body);
      return response.data;
    } catch (error) {
        console.error("Error importing and saving items:", error);
        return [];
    }
  }
};